import { StateManager } from "./state-manager"

export interface ReactionStep {
  set?: string
  value?: unknown
  delay?: number
}

export interface Reaction {
  onChange: ReactionStep[]
}

export class LocalStateManager {
  private localState = new Map<string, unknown>()
  private unsubs: Array<() => void> = []

  constructor(private globalState: StateManager) {}

  get(path: string): unknown {
    if (path.startsWith("@")) {
      return this.localState.get(path)
    }
    return this.globalState.get(path)
  }

  set(path: string, value: unknown): void {
    if (path.startsWith("@")) {
      this.localState.set(path, value)
    }
  }

  registerReaction(watchPath: string, reaction: Reaction): void {
    const unsub = this.globalState.subscribe(watchPath, () => {
      this.executeReactionSteps(reaction.onChange)
    })
    this.unsubs.push(unsub)
  }

  private async executeReactionSteps(steps: ReactionStep[]): Promise<void> {
    for (const step of steps) {
      if (step.delay != null) {
        await new Promise((r) => setTimeout(r, step.delay))
      } else if (step.set != null) {
        this.set(step.set, step.value)
      }
    }
  }

  destroy(): void {
    for (const unsub of this.unsubs) unsub()
    this.unsubs = []
    this.localState.clear()
  }
}
